import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards } from 'swiper/modules';

Swiper.use([Navigation, Pagination, Autoplay, EffectCoverflow, EffectCards]);
document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.swiper-slider').forEach(function(slider) {

        let defaults = {
            effect: 'slide',
            autoplay: {delay: 5000},
            keyboard: true,
            loop: true,
            navigation: {
                enabled: false,
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination-progressbar-fill',
                clickable: false,
                type: 'progressbar',
            },
        };

        let options = Object.assign({}, defaults, JSON.parse(slider.dataset.options || '{}'));
        // console.log(options)
        new Swiper(slider, options);
    });

     var swiper = new Swiper('.postsslider-container', {
        autoplay: false,
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        pagination: false,
        breakpoints: {
            // when window width is >= 320px
            768: {
              slidesPerView: 2,
            },
            // when window width is >= 480px
            990: {
              slidesPerView: 3,
            }
          }
      });


    var swiper = new Swiper('.swiper-container', {
        effect: 'slide',
        autoplay: {delay: 5000},
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
        },
        navigation: false
      });

    var svw = jQuery('.swiper.tarifswiper').attr('data-swiper-slidesperview');

    const swipertarif = new Swiper(".tarifswiper", {
      // effect: "cards",
      initialSlide: 0,
      grabCursor: false,
      allowTouchMove: false,
      centeredSlides: true,
      // autoplay: {delay: 8000},
      centerInsufficientSlides: true,
      centeredSlidesBounds: false,
      loop: true,
      slidesPerView: 1,
      navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },

      breakpoints: {
            // when window width is >= 320px
            1199: {
              slidesPerView: svw,
            },
      },
      on: {
        reachEnd: function (ev) {
            console.log(ev);
        },
        init: function () {
            var maxHeight = 0;

            jQuery(".swiper-slide .tarif-item").each(function(){
               var thisH = jQuery(this).height();
               if (thisH > maxHeight) { maxHeight = thisH; }
            });

            jQuery(".swiper-slide .tarif-item").height(maxHeight);
        },
    click: function (ev) {
        if (!jQuery(ev.clickedSlide).hasClass('swiper-slide-active')) {
            var slidto = ev.clickedSlide.getAttribute('data-slideto');
            // if (this.clickedIndex > 2) {
            //     slidto = parseInt(slidto)-1;
            // }
            console.log("=="+slidto);
            ev.slideToLoop(slidto);
        }
        // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
        // console.log(this.clickedIndex, this.realIndex);
    },
  }
      // slideToClickedSlide: true,

    // loopAdditionalSlides: 100,
      // cardsEffect: {
      //   perSlideOffset: 100,
      //   rotate: false
      //   },
      // pagination: {
      //   el: ".swiper-pagination",
      //   clickable: true,
      // },
      // navigation: false
    });

     // effect: "coverflow",
     //  grabCursor: true,
     //  centeredSlides: true,
     //  slidesPerView: "auto",
     //  loop: true,
     //  coverflowEffect: {
     //    rotate: 50,
     //    stretch: 0,
     //    depth: 100,
     //    modifier: 1,
     //    slideShadows: true,
     //  },

    console.log("===tarif====");


    jQuery('#pricing_section .tarifslider-toggle button').click(function(){
        var showclass = this.dataset.value;
jQuery(this).parent('.togglebutton_wrap').find('button').removeClass('t-active');
          jQuery(this).addClass('t-active');

        var data = {
            action: "updatetarifslider_call",
            cattoshow: showclass
        };

        


        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: "action=" + data.action + "&togglecat=" + data.cattoshow,
            success: function(response) {
                setswipe();
                 jQuery(".tarifswiper.swiper .swiper-wrapper").html(response);
                 console.log('Response:', response);

                 inittarifswiper();
                // const jsonObject = JSON.parse(response);
                // console.log('Object value:', jsonObject.systemOperator);

                // jQuery('#tarif-result').toggle();
            }
        });
/*
        const swiper_aftinit = document.querySelector('.tarifswiper').swiper;
        swiper_aftinit.destroy();

        var showclass = jQuery('.togglebutton_wrap button').get(0).dataset.value;
          jQuery(this).parent('.togglebutton_wrap').find('button').removeClass('t-active');
          jQuery(this).addClass('t-active');

            if (!t_toggle_pub && !t_toggle_pri) {
               t_toggle_pub = jQuery(".swiper-slide.public").clone();
               t_toggle_pri = jQuery(".swiper-slide.private").clone();
            }


           jQuery(".swiper-slide:not(."+showclass+")").remove();

          if (showclass == "private") {
            console.log("==");
            console.log(t_toggle_pri);
                    jQuery(".tarifswiper.swiper .swiper-wrapper").append(t_toggle_pri);
            }
          if (showclass == "public") {
            console.log("==pub");
            console.log(t_toggle_pub);
                    jQuery(".tarifswiper.swiper .swiper-wrapper").append(t_toggle_pub);
            }

        
        var slides = jQuery('.swiper-slide.slidedups').length;
        var vv = 3;
        if (slides > 5) {
            vv = 5
        }else{
            vv = slides;
        }

      // const swiper_aftinit = document.querySelector('.tarifswiper').swiper;
      //   swiper_aftinit.destroy();

        var svw = jQuery('.tarifswiper').attr('data-swiper-slidesperview');
        jQuery('.tarifswiper').attr('data-swiper-slidesperview', vv);
        jQuery('.tarifswiper').removeClass('tarfislides-'+svw);
        jQuery('.tarifswiper').addClass('tarfislides-'+vv);
   console.log("initialSlide");
    const swipertarif = new Swiper(".tarifswiper", {
              // effect: "cards",
              initialSlide: 0,
              grabCursor: false,
              allowTouchMove: false,
              centeredSlides: true,
              centerInsufficientSlides: true,
              centeredSlidesBounds: false,
              slidesPerView: vv,
              loop: true,

              on: {
                reachEnd: function (ev) {
                    console.log(ev);
                },
                init: function () {
                    var maxHeight = 0;

                    jQuery(".swiper-slide .tarif-item").each(function(){
                       var thisH = jQuery(this).height();
                       if (thisH > maxHeight) { maxHeight = thisH; }
                    });

                    jQuery(".swiper-slide .tarif-item").height(maxHeight);
                },
            click: function (ev) {
                if (!jQuery(ev.clickedSlide).hasClass('swiper-slide-active')) {
                    var slidto = ev.clickedSlide.getAttribute('data-slideto');
                    // if (this.clickedIndex > 2) {
                    //     slidto = parseInt(slidto)-1;
                    // }
                    // console.log("=="+slidto);
                    ev.slideToLoop(slidto);
                }
                // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
                // console.log(this.clickedIndex, this.realIndex);
            },
          }

            });

*/
    });




jQuery('#tarife_page .tarifslider-toggle button').click(function(){
        var showclass = this.dataset.value;
        jQuery(this).parent('.togglebutton_wrap').find('button').removeClass('t-active');
          jQuery(this).addClass('t-active');

        var data = {
            action: "updatetarifpage_call",
            cattoshow: showclass
        };

        


        jQuery.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: "action=" + data.action + "&togglecat=" + data.cattoshow,
            success: function(response) {
                 jQuery("#tarif_page_container").html(response);
                 console.log('Response:', response);

            }
        });

});


});


function setswipe(){
        
       const swiper_aftinit = document.querySelector('.tarifswiper').swiper;
        swiper_aftinit.destroy();
    }

function inittarifswiper(vv) {
    var slides = jQuery('.swiper-slide.slidedups').length;
        var vv = 3;
        if (slides > 5) {
            vv = 5
        }else{
            vv = slides;
        }

        var svw = jQuery('.tarifswiper').attr('data-swiper-slidesperview');
        jQuery('.tarifswiper').attr('data-swiper-slidesperview', vv);
        jQuery('.tarifswiper').removeClass('tarfislides-'+svw);
        jQuery('.tarifswiper').addClass('tarfislides-'+vv);
    console.log("initialSlide");
    var initparam = {
              // effect: "cards",
              initialSlide: 0,
              grabCursor: false,
              allowTouchMove: false,
              centeredSlides: true,
              centerInsufficientSlides: true,
              centeredSlidesBounds: false,
              loop: true,
              slidesPerView: 1,
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
              },
      
              breakpoints: {
                    // when window width is >= 320px
                    1199: {
                      slidesPerView: vv,
                    },
              },

              on: {
                reachEnd: function (ev) {
                    console.log(ev);
                },
                init: function () {
                    var maxHeight = 0;

                    jQuery(".swiper-slide .tarif-item").each(function(){
                       var thisH = jQuery(this).height();
                       if (thisH > maxHeight) { maxHeight = thisH; }
                    });

                    jQuery(".swiper-slide .tarif-item").height(maxHeight);
                },
            click: function (ev) {
                if (!jQuery(ev.clickedSlide).hasClass('swiper-slide-active')) {
                    var slidto = ev.clickedSlide.getAttribute('data-slideto');
                    // if (this.clickedIndex > 2) {
                    //     slidto = parseInt(slidto)-1;
                    // }
                    // console.log("=="+slidto);
                    ev.slideToLoop(slidto);
                }
                // console.log(this.clickedSlide.getAttribute('data-swiper-slide-index'));
                // console.log(this.clickedIndex, this.realIndex);
            },
          }

            };
            
            if (vv < 3) {
                initparam.loop = false;
            }
    const swipertarif = new Swiper(".tarifswiper", initparam);
}